function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import { jsx, ParamComponent } from 'panel';
import { selx } from 'clsx';
import uniqBy from 'lodash/uniqBy';
import { NoExtension, Section, SectionItem } from 'common/components/items-menu/types';
import { getOrderedSearchContextDisplayOptions, getReportNameFromSearchContext, getSearchIconFromDisplayContext, getSuggestedCreators } from 'common/report/util/search';
import { SearchDisplayContext, SearchDisplayContextTranslation } from 'common/report/util/search/types';
import { defineAndMakeJsxFactory } from 'common/util/jsx';
import { panel2react } from 'common/util/react';
import { ItemsMenuEl } from 'common/components/items-menu';
import { getDashboardAllowedReports } from 'common/report/util/boards';
import { IronContextRegistry } from 'common/report/context-registry';
import { TopCreator } from 'common/report/queries/app-api/project-top-creators';
import { UserSelectorEl } from 'common/widgets/user-selector';
import { userCookieUtils } from 'common/report/util/user-identity-from-cookie';
import { BrowseTrackedEvent } from 'common/report/util/search/tracking';
import { getProjectId, getWorkspaceId } from 'common/report/util';
import { EntrySectionUpdates, QueryEventEntry, RowLabelType } from 'common/query-builder/query-entry-section/types';
import { ResourceType } from 'common/report/constants';
import { QueryEntrySectionEl } from 'common/query-builder/query-entry-section/panel';
import { ButtonTheme } from 'common/components/button/constants';
import { FilterType, SearchFilter, ShareStatusFilter } from '../types';
import styles from './index.module.styl';
import queryEntrySectionStyleOverride from './query-entry-section.inline.styl';
type BrowseFilterJsxProps = {
  params: BrowseFilterParams;
};
type BrowseFilterParams = {
  filter: SearchFilter;
  onFilterChange: (filter: SearchFilter) => void;
  onTrackEvent?: (event: BrowseTrackedEvent, props?: Record<string, any>) => void;
  isAddMode: boolean;
  userId: number;
};
type OwnerFilterItem = SectionItem<ShareStatusFilter, {
  filterType: FilterType.ShareStatus;
}>;
type ReportFilterItem = SectionItem<SearchDisplayContext, {
  filterType: FilterType.Report;
}>;
type CreatorFilterItem = SectionItem<string, {
  filterType: FilterType.CreatorEmail;
  creator: TopCreator;
}>;
type BrowseFilterItem = OwnerFilterItem | ReportFilterItem | CreatorFilterItem;
type BrowseFilterSection = Section<any, NoExtension, BrowseFilterItem>;
export class BrowseFilter extends ParamComponent<BrowseFilterParams, EmptyObj, IronContextRegistry> {
  get config() {
    return {
      contexts: ["currentProject" as const, "projectTopCreators" as const, "i18n" as const],
      template: () => {
        const eventEntries = FilterType.Event in this.params.filter ? this.params.filter[FilterType.Event].map(eventName => {
          return {
            type: ResourceType.Event,
            event: {
              value: eventName
            },
            filters: []
          } as QueryEventEntry;
        }) : [];
        return <div sel={selx(styles.browseFiltersContainer)}>
            <div sel={selx(styles.creatorFilterContainer)}>
              <div sel={selx(styles.creatorFilterLabel)}>{this.t("discover.filter.creators")}</div>
              <UserSelectorEl sel={selx(styles.creatorFilter)} params={{
              users: this.getCreatorsList(),
              selectedUsers: this.getSelectedCreators(),
              icon: "profile",
              label: this.getSelectedCreators().length ? this.t("discover.filter.created-by") : this.t("discover.filter.created-by-anyone"),
              searchPlaceholder: this.t("discover.filter.search-creator-placeholder"),
              onSelectedUsersChange: item => {
                const {
                  isSelected,
                  value
                } = item;
                const filterType = FilterType.CreatorEmail;
                this.handleFilterChange({
                  isSelected,
                  value,
                  filterType
                });
              },
              onMenuChange: isOpen => {
                this.handleCreatorFilterMenuChange(isOpen);
              }
            }} />
            </div>
            <ItemsMenuEl attrs={{
            multiple: true,
            elref: "browseFilterMenu"
          }} props={{
            sections: this.getTypeFilterSections()
          }} on={{
            clickItem: ev => this.handleFilterChange(ev.detail.item)
          }} />
            <div sel={selx(styles.eventSection)}>
              <div sel={selx(styles.eventSectionHeader)}>{this.t("discover.filter.events-label")}</div>
              <QueryEntrySectionEl styleOverride={queryEntrySectionStyleOverride} autofocus={false} addEntryLabel={this.t("discover.filter.entry-label")} addEntryButtonLabel={this.t("discover.filter.entry-btn-label")} addEntryButtonTooltipText={this.t("discover.filter.entry-btn-tooltip")} buttonTheme={ButtonTheme.Browse} disableAddEventFilters disableAddGroupedEventReason='true' disableCloneEntry disableFirstTimeEventFilters enableEventIcon entries={eventEntries} minEntries={0} excludeAutotrackEvents excludeDimensionProperties projectHasPeople hideEvents projectHasCohorts projectId={parseInt(getProjectId())} rowLabelType={RowLabelType.None} rowTypes={[ResourceType.Event]} userId={this.params.userId} workspaceId={parseInt(getWorkspaceId())} onUpdate={(updates: EntrySectionUpdates<QueryEventEntry>) => {
              this.params.onFilterChange(_objectSpread(_objectSpread({}, this.params.filter), {}, {
                [FilterType.Event]: updates.entries.map(entry => entry.event.value)
              }));
            }} />
            </div>
          </div>;
      },
      params: {
        filter: Object,
        onFilterChange: Function,
        onTrackEvent: Function,
        isAddMode: Boolean,
        userId: Number
      }
    };
  }
  get t() {
    return this.getContext("i18n").t;
  }
  handleFilterChange(item) {
    var _this$params$onTrackE, _this$params;
    const {
      isSelected,
      filterType,
      value
    } = item;
    let filterValues = this.params.filter[filterType];
    if (isSelected) {
      filterValues = filterValues.filter(currVal => currVal !== value);
    } else {
      filterValues = [...filterValues, value];
    }
    this.params.onFilterChange(_objectSpread(_objectSpread({}, this.params.filter), {}, {
      [filterType]: filterValues
    }));
    (_this$params$onTrackE = (_this$params = this.params).onTrackEvent) === null || _this$params$onTrackE === void 0 || _this$params$onTrackE.call(_this$params, BrowseTrackedEvent.FilterUpdated, {
      'Changed Filter Type': filterType,
      'Changed Filter Value': value,
      'Is Filter Value Selected': !isSelected
    });
  }
  handleCreatorFilterMenuChange(isOpen) {
    if (isOpen) {
      var _this$params$onTrackE2, _this$params2;
      (_this$params$onTrackE2 = (_this$params2 = this.params).onTrackEvent) === null || _this$params$onTrackE2 === void 0 || _this$params$onTrackE2.call(_this$params2, BrowseTrackedEvent.CreatorFilterMenuOpened);
    }
  }
  getTypeFilterSections(): BrowseFilterSection[] {
    return [{
      label: this.t("discover.filter.types-label"),
      items: this.getAvailableReports().map(value => ({
        label: SearchDisplayContextTranslation[value],
        icon: getSearchIconFromDisplayContext(value),
        value,
        isSelected: this.params.filter[FilterType.Report].includes(value),
        filterType: FilterType.Report
      }))
    }];
  }
  getCreatorsList() {
    var _userCookieUtils$getU;
    const topCreators = this.getTopCreators();
    const orderedCreatorList = uniqBy([...getSuggestedCreators((_userCookieUtils$getU = userCookieUtils.getUserIdentityFromCookie()) === null || _userCookieUtils$getU === void 0 ? void 0 : _userCookieUtils$getU.id, topCreators), ...topCreators], (creator: TopCreator) => creator.email);
    orderedCreatorList.map(creator => ({
      id: creator.id,
      email: creator.email,
      name: creator.name
    }));
    return orderedCreatorList;
  }
  getTopCreators(): TopCreator[] {
    return this.getContext("projectTopCreators").getCreators();
  }
  getAvailableReports() {
    let reports = getOrderedSearchContextDisplayOptions();
    if (this.params.isAddMode) {
      reports = reports.filter(report => {
        const reportFromContext = getReportNameFromSearchContext(report);
        return getDashboardAllowedReports().includes(reportFromContext);
      });
    }
    return reports;
  }
  getSelectedCreators() {
    return this.params.filter[FilterType.CreatorEmail] || [];
  }
}
export const BrowseFilterEl = defineAndMakeJsxFactory<BrowseFilterJsxProps>("browse-filter", BrowseFilter);
export const BrowseFilterReact = panel2react<BrowseFilterJsxProps>("browse-filter", BrowseFilter);